<template>
  <div id="DataDictionary" style="margin: 0px auto">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>数据字典</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main-box">
      <template v-for="fun in dataList">
        <div class="fun-name">{{ fun.funName }}</div>
        <el-table ref="table" :data="fun.dictionarys" stripe size="mini" :highlight-current-row="true">
          <el-table-column prop="filed" label="字段名称" width="150px" align="right" :key="109"> </el-table-column>
          <el-table-column prop="des" label="解释说明" :key="111">
            <template slot-scope="scope">
              {{ "=" + scope.row.des }}
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [
        {
          funName: "库存规划",
          dictionarys: [
            {
              filed: "应采购",
              des: "目标库存-亚马逊库存-本地库存-采购中",
            },
            {
              filed: "采购中",
              des: "本地库存-采购中",
            },
            {
              filed: "本地库存",
              des: "本地库存",
            },
            {
              filed: "应补货",
              des: "日销量*（亚马逊备货周期 + 头程备货周期）* 7 - 亚马逊合计库存",
            },
            {
              filed: "可补货",
              des: "应补货>本地库存，取本地库存，反之，取应补货",
            },
            {
              filed: "日销量",
              des: "以此取7日、14日、30日、90日访客先大于100对应转化率，日销量=7日访客*转换率/7",
            },
            {
              filed: "补货物流",
              des: "红单快递（2周）、美森正班（4周）、海卡海派（6周）",
            },
            {
              filed: "出库中",
              des: "所有状态为出库中记录的数量之和",
            },
            {
              filed: "亚马逊备货周期",
              des: "默认4周，动态计算30日销量大于等于30单的SKU取6周，同时乘以调价比例",
            },
            {
              filed: "头程备货周期",
              des: "默认4周，动态计算30日销量大于等于30单的SKU取6周，同时乘以调价比例",
            },
            {
              filed: "本地备货周期",
              des: "默认2周，可动态配置，同时乘以调价比例",
            },
            {
              filed: "目标库存",
              des: "日销量*（亚马逊备货周期 + 头程备货周期 + 本地备货周期）* 7",
            },
            {
              filed: "合计库存",
              des: "采购中+可用+头程+正在接收+预留（部分预留为出货订单）",
            },
            {
              filed: "亚马逊库存",
              des: "可用+头程+正在接收+预留",
            },
            {
              filed: "可用",
              des: "可售卖",
            },
            {
              filed: "预留",
              des: "已到货，不可售库存，包括已出单占用库存",
            },
            {
              filed: "入库",
              des: "头程库存",
            },
            {
              filed: "1周内上架",
              des: "1~7日内可上架",
            },
            {
              filed: "2周内上架",
              des: "8~14日内可上架",
            },
            {
              filed: "3周内上架",
              des: "15~21日内可上架",
            },
            {
              filed: "4周内上架",
              des: "22~28日内可上架",
            },
            {
              filed: "5周内上架",
              des: "29~35日内可上架",
            },
            {
              filed: "超5周上架",
              des: "35日以上可上架",
            },
            {
              filed: "处理中",
              des: "已建货件，未发货库存",
            },
            {
              filed: "已发货",
              des: "已建货件，已发货库存",
            },
            {
              filed: "正在接收",
              des: "已到货未上架库存",
            },
            {
              filed: "亚马逊库存天数",
              des: "合计库存/日销量",
            },
            {
              filed: "可用库存天数",
              des: "亚马逊库存/日销量",
            },
          ],
        },
        {
          funName: "采购管理",
          dictionarys: [
            {
              filed: "应采购",
              des: "库存规划-应采购，可手动调节",
            },
            {
              filed: "已采购",
              des: "手工填写",
            },
            {
              filed: "待采购",
              des: "应采购-已采购",
            },
            {
              filed: "已到货",
              des: "手工填写",
            },
            {
              filed: "已发货",
              des: "手工填写",
            },
            {
              filed: "待发货",
              des: "已到货-已发货",
            },
            {
              filed: "实际缺货",
              des: "已采购-已到货",
            },
            {
              filed: "待退款",
              des: "等于实际缺货",
            },
            {
              filed: "已退款",
              des: "手工填写",
            },
            {
              filed: "待补货",
              des: "待退款-已退款",
            },
            {
              filed: "多到库存",
              des: "已到货-已采购",
            },
            {
              filed: "已退回",
              des: "手工填写",
            },
            {
              filed: "实际多收库存",
              des: "多到库存-已退回",
            },
            {
              filed: "已采未到",
              des: "已采购-已到货-已退款-已退回",
            },
          ],
        },
        {
          funName: "本地库存",
          dictionarys: [
            {
              filed: "本地库存",
              des: "旧采购(已到货-已发货-已退货)+采购记录入库数量-已出库(出库计划)+拆分量",
            },
            {
              filed: "采购中",
              des: "旧采购(应采购-已到货-已退款-已退货)+采购记录(采购数量-入库-已结清质检-缺货；换货质检仍计采购中；已完成不计)",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
#DataDictionary {
  .breadcrumb-box {
    .el-breadcrumb {
      margin: 20px 0px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .main-box {
    background-color: white;
    padding: 20px;
  }
}
</style>
